<template>
    <section class="uses-tailwind px-5 min-h-[calc(100vh_-_120px)]">
        <loader
            v-if="isLoadingMaterialType || isSavingMaterialType"
            :cover="true"
            :message="
                isLoadingMaterialType
                    ? trans('material_types.feedback.loading_material_type')
                    : trans('material_types.feedback.saving_material_type')
            "
        />
        <div v-if="materialType">
            <div class="flex items-center justify-between mb-5">
                <div class="flex items-center gap-2">
                    <ui5-button
                        class="border border-primary hover:text-primary"
                        v-on:click="$router.push('/material-types')"
                    >
                        {{ trans('material_types.actions.back_to_overview') }}
                    </ui5-button>
                </div>
                <div class="flex items-center gap-2">
                    <ui5-button
                        class="border border-primary hover:text-primary"
                        v-on:click="updateMaterialType()"
                    >
                        {{
                            trans('material_types.actions.update_material_type')
                        }}
                    </ui5-button>
                    <ui5-button
                        class="border border-primary hover:text-primary"
                        v-on:click="toggleDeleteModal(true)"
                    >
                        {{
                            trans('material_types.actions.delete_material_type')
                        }}
                    </ui5-button>
                </div>
            </div>
            <div class="grid grid-cols-3 gap-5">
                <div>
                    <h2 class="font-bold text-xl mb-2">
                        {{ trans('material_types.titles.general') }}
                    </h2>
                    <ui5-label class="text-lg">
                        {{ trans('material_types.form.labels.name') }}
                    </ui5-label>
                    <ui5-input
                        class="w-full"
                        v-bind:value="materialType.name"
                        v-on:change="
                            $set(materialType, 'name', $event.target.value)
                        "
                    />
                    <div
                        v-if="getErrorFromValidator($v.materialType.name)"
                        class="error"
                    >
                        {{ getErrorFromValidator($v.materialType.name) }}
                    </div>
                </div>
                <div class="col-span-3">
                    <h2 class="font-bold text-xl mb-2">
                        {{ trans('material_types.titles.deduction_table') }}
                    </h2>
                    <table class="uses-tailwind table table-auto w-full">
                        <thead class="border-b border-slate-800">
                            <tr>
                                <th class="px-4 py-2 font-bold text-start">
                                    {{
                                        trans(
                                            'material_types.deduction_table.columns.forming_press'
                                        )
                                    }}
                                </th>
                                <th class="px-4 py-2 font-bold text-start">
                                    {{
                                        trans(
                                            'material_types.deduction_table.columns.stamp'
                                        )
                                    }}
                                </th>
                                <th class="px-4 py-2 font-bold text-start">
                                    {{
                                        trans(
                                            'material_types.deduction_table.columns.stamp_die'
                                        )
                                    }}
                                </th>
                                <th class="px-4 py-2 font-bold text-start">
                                    {{
                                        trans(
                                            'material_types.deduction_table.columns.thickness'
                                        )
                                    }}
                                </th>
                                <th class="px-4 py-2 font-bold text-start">
                                    {{
                                        trans(
                                            'material_types.deduction_table.columns.angle'
                                        )
                                    }}
                                </th>
                                <th class="px-4 py-2 font-bold text-start">
                                    {{
                                        trans(
                                            'material_types.deduction_table.columns.value'
                                        )
                                    }}
                                </th>
                                <th class="px-4 py-2 font-bold text-start">
                                    {{ trans('general.actions') }}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-for="(
                                    angleDeduction, index
                                ) in angleDeductions"
                                v-bind:key="index"
                                class="odd:bg-slate-100"
                            >
                                <td class="px-4 py-2">
                                    <ui5-input
                                        class="w-full"
                                        v-bind:value="
                                            angleDeduction.formingPress
                                        "
                                        v-on:change="
                                            $set(
                                                angleDeduction,
                                                'formingPress',
                                                $event.target.value
                                            )
                                        "
                                    />
                                    <div
                                        v-if="
                                            $v.angleDeductions.$each[index] &&
                                            getErrorFromValidator(
                                                $v.angleDeductions.$each[index]
                                                    .formingPress
                                            )
                                        "
                                        class="error"
                                    >
                                        {{
                                            getErrorFromValidator(
                                                $v.angleDeductions.$each[index]
                                                    .formingPress
                                            )
                                        }}
                                    </div>
                                </td>
                                <td class="px-4 py-2">
                                    <ui5-input
                                        class="w-full"
                                        v-bind:value="angleDeduction.stamp"
                                        v-on:change="
                                            $set(
                                                angleDeduction,
                                                'stamp',
                                                $event.target.value
                                            )
                                        "
                                    />
                                    <div
                                        v-if="
                                            $v.angleDeductions.$each[index] &&
                                            getErrorFromValidator(
                                                $v.angleDeductions.$each[index]
                                                    .stamp
                                            )
                                        "
                                        class="error"
                                    >
                                        {{
                                            getErrorFromValidator(
                                                $v.angleDeductions.$each[index]
                                                    .stamp
                                            )
                                        }}
                                    </div>
                                </td>
                                <td class="px-4 py-2">
                                    <ui5-input
                                        class="w-full"
                                        v-bind:value="angleDeduction.stampDie"
                                        v-on:change="
                                            $set(
                                                angleDeduction,
                                                'stampDie',
                                                $event.target.value
                                            )
                                        "
                                    />
                                    <div
                                        v-if="
                                            $v.angleDeductions.$each[index] &&
                                            getErrorFromValidator(
                                                $v.angleDeductions.$each[index]
                                                    .stampDie
                                            )
                                        "
                                        class="error"
                                    >
                                        {{
                                            getErrorFromValidator(
                                                $v.angleDeductions.$each[index]
                                                    .stampDie
                                            )
                                        }}
                                    </div>
                                </td>
                                <td class="px-4 py-2">
                                    <text-input
                                        class="w-full"
                                        type="number"
                                        step="0.01"
                                        v-bind:value="angleDeduction.thickness"
                                        v-on:change="
                                            $set(
                                                angleDeduction,
                                                'thickness',
                                                $event
                                            )
                                        "
                                    />
                                    <div
                                        v-if="
                                            $v.angleDeductions.$each[index] &&
                                            getErrorFromValidator(
                                                $v.angleDeductions.$each[index]
                                                    .thickness
                                            )
                                        "
                                        class="error"
                                    >
                                        {{
                                            getErrorFromValidator(
                                                $v.angleDeductions.$each[index]
                                                    .thickness
                                            ) ===
                                            'general.validation.decimal_precision'
                                                ? trans(
                                                      'general.validation.decimal_precision',
                                                      {
                                                          precision: 2,
                                                      }
                                                  )
                                                : getErrorFromValidator(
                                                      $v.angleDeductions.$each[
                                                          index
                                                      ].thickness
                                                  )
                                        }}
                                    </div>
                                </td>
                                <td class="px-4 py-2">
                                    <text-input
                                        class="w-full"
                                        type="number"
                                        step="1"
                                        v-bind:value="angleDeduction.angle"
                                        v-on:change="
                                            $set(
                                                angleDeduction,
                                                'angle',
                                                $event
                                            )
                                        "
                                    />
                                    <div
                                        v-if="
                                            $v.angleDeductions.$each[index] &&
                                            getErrorFromValidator(
                                                $v.angleDeductions.$each[index]
                                                    .angle
                                            )
                                        "
                                        class="error"
                                    >
                                        {{
                                            getErrorFromValidator(
                                                $v.angleDeductions.$each[index]
                                                    .angle
                                            )
                                        }}
                                    </div>
                                </td>
                                <td class="px-4 py-2">
                                    <text-input
                                        class="w-full"
                                        type="number"
                                        step="0.0001"
                                        v-bind:value="angleDeduction.value"
                                        v-on:change="
                                            $set(
                                                angleDeduction,
                                                'value',
                                                $event
                                            )
                                        "
                                    />
                                    <div
                                        v-if="
                                            $v.angleDeductions.$each[index] &&
                                            getErrorFromValidator(
                                                $v.angleDeductions.$each[index]
                                                    .value
                                            )
                                        "
                                        class="error"
                                    >
                                        {{
                                            getErrorFromValidator(
                                                $v.angleDeductions.$each[index]
                                                    .value
                                            ) ===
                                            'general.validation.decimal_precision'
                                                ? trans(
                                                      'general.validation.decimal_precision',
                                                      {
                                                          precision: 4,
                                                      }
                                                  )
                                                : getErrorFromValidator(
                                                      $v.angleDeductions.$each[
                                                          index
                                                      ].value
                                                  )
                                        }}
                                    </div>
                                </td>
                                <td>
                                    <ui5-button
                                        class="border border-primary hover:text-primary"
                                        v-on:click="removeAngleDeduction(index)"
                                    >
                                        {{
                                            trans(
                                                'material_types.actions.remove_angle_deduction'
                                            )
                                        }}
                                    </ui5-button>
                                </td>
                            </tr>
                            <tr>
                                <td
                                    colspan="7"
                                    class="px-4 py-2"
                                >
                                    <div
                                        class="w-full flex items-center justify-center"
                                    >
                                        <ui5-button
                                            class="border border-primary hover:text-primary"
                                            v-on:click="addAngleDeduction"
                                        >
                                            {{
                                                trans(
                                                    'material_types.actions.add_angle_deduction'
                                                )
                                            }}
                                        </ui5-button>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <modal
            v-if="materialType"
            :show="deleteModal.show"
            :loading="deleteModal.loading"
            :actions="deleteModal.actions"
            @close="toggleDeleteModal(false)"
            :title="trans('material_types.delete_modal.title')"
        >
            <p>
                {{
                    trans('material_types.delete_modal.message', {
                        name: materialType.name,
                    })
                }}
            </p>
        </modal>
    </section>
</template>

<script>
import localization from '../mixins/localization';
import Loader from '../components/loader/Loader';
import Modal from '../components/modals/Modal';
import {
    showConfirmDialog,
    showErrorMessage,
    showInfoMessage,
} from '../dialogs';
import materialTypesApi from '../api/materialTypes';
import { required, integer } from 'vuelidate/lib/validators';
import ErrorHelper from '../helpers/ErrorHelper';
import { validDecimalPrecision } from '../validators/validDecimalPrecision';
import TextInput from '../components/TextInput.vue';

const decimalPrecision = (precision) => (value) => {
    if (!value) return true;
    const regex = new RegExp(`^\\d+(\\.\\d{1,${precision}})?$`);
    return regex.test(value);
};

export default {
    data() {
        return {
            materialType: null,
            angleDeductions: [],
            isLoadingMaterialType: false,
            isSavingMaterialType: false,
            deleteModal: {
                show: false,
                loading: false,
                actions: [
                    {
                        label: this.trans(
                            'material_types.delete_modal.actions.cancel'
                        ),
                        handler: () => {
                            this.toggleDeleteModal(false);
                        },
                    },
                    {
                        label: this.trans(
                            'material_types.delete_modal.actions.delete'
                        ),
                        theme: 'primary',
                        handler: () => {
                            this.deleteMaterialType();
                        },
                    },
                ],
            },
        };
    },
    validations() {
        return {
            materialType: {
                name: { required },
            },
            angleDeductions: {
                $each: {
                    formingPress: { required },
                    stamp: { required },
                    stampDie: { required },
                    thickness: {
                        required,
                        validDecimalPrecision: validDecimalPrecision(2),
                    },
                    angle: { required, integer },
                    value: {
                        required,
                        validDecimalPrecision: validDecimalPrecision(4),
                    },
                },
            },
        };
    },
    mounted() {
        this.fetchMaterialType();
    },
    methods: {
        getErrorFromValidator: ErrorHelper.getErrorFromValidator,
        fetchMaterialType() {
            this.isLoadingMaterialType = true;

            materialTypesApi
                .fetchById(this.$route.params.id)
                .then((response) => {
                    if (!response.data || !response.data.data) {
                        throw new Error();
                    }

                    this.materialType = response.data.data;
                    this.angleDeductions = this.materialType.angleDeductions;
                })
                .catch((error) => {
                    showErrorMessage(
                        this.trans(
                            'material_types.errors.fetching_material_type'
                        )
                    );
                })
                .finally(() => {
                    this.isLoadingMaterialType = false;
                });
        },
        toggleDeleteModal(open = true) {
            this.$set(this.deleteModal, 'show', open);
        },
        toggleDeleteModalLoading(loading = true) {
            this.$set(this.deleteModal, 'loading', loading);
        },
        deleteMaterialType() {
            materialTypesApi
                .delete(this.materialType.id)
                .then((response) => {
                    showInfoMessage(
                        this.trans(
                            'material_types.feedback.material_type_deleted'
                        )
                    );
                    this.goToOverview();
                })
                .catch((error) => {
                    showErrorMessage(
                        this.trans(
                            'material_types.errors.deleting_material_type'
                        )
                    );
                })
                .finally(() => {
                    this.toggleDeleteModalLoading(false);
                    this.toggleDeleteModal(false);
                });
        },
        goToOverview() {
            this.$router.push('/material-types');
        },
        isValid() {
            let valid = true;

            [this, ...Object.values(this.$refs).flat()].forEach((x) => {
                if (x.$v) {
                    x.$v.$touch();

                    if (x.$v.$invalid) {
                        valid = false;
                    }
                }
            });

            return valid;
        },
        updateMaterialType() {
            this.isSavingMaterialType = true;

            if (!this.isValid()) {
                this.isSavingMaterialType = false;

                return showErrorMessage(
                    this.trans('material_types.errors.invalid_form')
                );
            }

            materialTypesApi
                .update(this.materialType.id, this.materialType)
                .then((response) => {
                    if (!response.data || !response.data.data) {
                        throw new Error();
                    }

                    return materialTypesApi.storeAngleDeductions(
                        this.materialType.id,
                        {
                            angleDeductions: this.angleDeductions,
                        }
                    );
                })
                .then((response) => {
                    if (!response.data || !response.data.data) {
                        throw new Error();
                    }

                    showInfoMessage(
                        this.trans(
                            'material_types.feedback.material_type_updated'
                        )
                    );

                    this.fetchMaterialType();
                })
                .catch((error) => {
                    showErrorMessage(
                        this.trans(
                            'material_types.errors.updating_material_type'
                        )
                    );
                })
                .finally(() => {
                    this.isSavingMaterialType = false;
                });
        },
        addAngleDeduction() {
            this.angleDeductions.push({
                id: null,
                formingPress: null,
                stamp: null,
                stampDie: null,
                thickness: null,
                angle: null,
                value: null,
            });
        },
        removeAngleDeduction(index) {
            this.angleDeductions = this.angleDeductions.filter(
                (angleDeduction, i) => {
                    return i !== index;
                }
            );
        },
    },
    mixins: [localization],
    components: {
        Loader,
        Modal,
        TextInput,
    },
};
</script>
